import gql from "graphql-tag";

export const FnaResults = gql`
  query fnaResults($fnaId: String!, $token: String!) {
    FnaResults(fnaId: $fnaId, token: $token) {
      FnaResultObj
      FnaDetails
    }
  }
`;

export const FnaById = gql`
  query fnaById($clientId: String!, $fnaId: Int) {
    FnaById(clientId: $clientId, fnaId: $fnaId) {
      form_data
      editMode
    }
  }
`;

export const GetFnaHistory = gql`
  query fnaHistory(
    $brokerId: String!
    $token: String!
    $limit: Int!
    $page: Int!
    $orderBy: String
    $direction: String
    $search: String
    $clientId: String
  ) {
    FnaHistory(
      brokerId: $brokerId
      token: $token
      limit: $limit
      page: $page
      orderBy: $orderBy
      direction: $direction
      search: $search
      clientId: $clientId
    ) {
      Count
      Results {
        id
        description
        date_created
        clientFullName
        client_id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/fna/queries.js